import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import { Product } from 'src/app/models/product';

@Component({
  selector: 'app-order-product-dialog',
  templateUrl: './order-product-dialog.component.html',
  styleUrls: ['./order-product-dialog.component.scss']
})
export class OrderProductDialog implements OnInit {
  public ready = false;
  public products: Product[] = [];
  public selectedProduct: Product = null;
  public btn_save_disabled = false;
  public btn_save_loader = false;

  public form = new FormGroup({
    comment: new FormControl(null),
  });

  constructor(
    public dialogRef: MatDialogRef<OrderProductDialog>,
    public dataService: DataService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.dataService.getAsPromise('admin/products/catalog').then(res => {
      this.products = (res?.data ?? []).map(p => new Product(p));
      this.ready = true;
    }).catch(() => { this.ready = true; });
  }

  selectProduct(product: Product) {
    this.selectedProduct = this.selectedProduct?.id === product.id ? null : product;
  }

  confirm() {
    if (!this.selectedProduct) return;
    this.btn_save_disabled = true;
    this.btn_save_loader = true;
    const payload = {
      product_id: this.selectedProduct.id,
      status: 'new',
      comment: this.form.value.comment,
    };
    this.dataService.postAsPromise('admin/orders', payload).then(res => {
      this.dialogRef.close({ order: res?.data });
    }).catch(() => {
      this.btn_save_disabled = false;
      this.btn_save_loader = false;
    });
  }
}
